import React, { Component } from 'react';
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux';

import { findCurrent as findCurrentUsage } from 'subscriptions/usage/sprint/actions';
import { 
  getCurrentUsage, getUser, getFilteredInsuranceContracts,
  getFilteredInsuredDevices, getFilteredPurchase,
} from 'reducers';
import { fetchData as fetchDataForLink } from 'insurance/Link/actions';
import { generateLinksList }  from 'insurance/Link/utils';

import ListItem from 'subscriptions/ListItem';

class SprintListItemComponent extends Component {

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(oldProps) {
    if (this.props.subscription.id !== oldProps.subscription.id) {
      this.fetchData();
    }
  }

  fetchData() {
    const { subscription, userId, findCurrentUsage, fetchDataForLink } = this.props;
    findCurrentUsage(subscription.id);
    fetchDataForLink({ subscription: subscription.id, userId });
  }

  handleClick = () => {
    const { contracts, devices, purchases, dispatch, subscription } = this.props;

    const linkTo = generateLinksList({
      contracts,
      devices,
      purchases,
      sprintSubId: subscription.id,
    })[0].to;

    dispatch(linkTo);

    return true;
  }

  render() {
    return <ListItem {...this.props} onClick={this.handleClick} />
  }
}

const mapStateToProps = (state, { subscription }) => {
  const contracts =  getFilteredInsuranceContracts(state, { subscription: subscription.id });
  const pendingContract = contracts.find( contract => contract.status === 'pending');

  const devices = pendingContract ? getFilteredInsuredDevices(state, pendingContract.id) : undefined;
  const activeDevice = devices ? devices.find(device => device.status === 'active') : undefined;
  const purchases = activeDevice ? getFilteredPurchase(state, activeDevice.activation_lineitem) : undefined;

  return  {
    usage: getCurrentUsage(state, subscription.id),
    userId: getUser(state) && getUser(state).id,
    contracts,
    devices,
    purchases,
  };
};

const mapDispatchToProps = dispatch => ({
  dispatch,
  ...bindActionCreators({
    findCurrentUsage,
    fetchDataForLink,
  }, dispatch),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SprintListItemComponent);
